<template src="./GridRowItem.html"></template>
<style scoped src="./GridRowItem.scss" lang="scss"></style>
<script>
import moment from "moment";
moment.locale("es");

import { mapGetters } from "vuex";

export default {
  props: {
    item: Object,
    rowexpanded: Boolean,
    highlighted: Boolean,
    indexSlide: Number
  },
  data: function() {
    return {
      styleObject: {
        backgroundImage: `url(${this.item.thumb})`
      },
      expanded: false
    };
  },
  computed: {
    ...mapGetters(["clientIsMobile"]),
    postTimeAgo: function() {
      let aDate = this.item.date.split("-");
      var a = moment([aDate[2], aDate[1], aDate[0]]);
      var b = moment();
      return a.from(b);
    }
  },
  mounted: function() {
    if(!this.$store.getters.initialLoadCompleted && this.item.id  ==  this.$store.getters.initialVideoIDlanguage)
    {
        this.$store.dispatch('setLoadComplete', true);
        this.showExpanded();
    }
  },
  methods: {
    goBig() {
      //solo hace rollover si la fila está cerrada
      if(!this.rowexpanded){
        if(!this.clientIsMobile){
          this.$emit("itemGoBigStarted",this.indexSlide);
          this.$el.classList.add("expanded");
        }
      }
    },
    goSmall() {
      if(!this.clientIsMobile){
        this.$emit("itemGoSmallStarted");
        this.$el.classList.remove("expanded");
      }
    },
    showExpanded(e) {
      if(this.clientIsMobile){
        this.$emit("itemSelectedMobile");
        // this.$emit("itemSelected");
      }else{
        this.$el.classList.remove("expanded");
        this.$emit("itemSelected");
      }
    },
    getAuthor() {
      return this.$store.getters.getAuthorById(parseInt(this.item.author));
    },
    playVideo() {
      this.$store.dispatch("activeVideoCinema", {
        activo: true,
        item: this.item,
        preview: false
      });
    }
  }
};
</script>
